import React, { useEffect, useState } from 'react';
import { Text, Button, Icon } from '../../Atoms';
import { InputProfileOrganism } from '../../Organisms';
import { Upload } from '../../Molecules';
import { ConfirmPasswordModal } from '../../Modals';
import { useHistory } from 'react-router';

function TemplateProfileScreen2(props) {
  const history = useHistory();

  const [windowWidth, setWindowWidth] = useState({
    innerWidth: window.innerWidth
  });
  useEffect(() => {
    window.addEventListener('resize', () => {
      setWindowWidth({ innerWidth: window.innerWidth });
    });
  }, []);
  console.log('PROPS TEMPLATE MAIN', props);
  return (
    <div className="template-scroll cartetp-container">
      <div className="cartetp-header-container profile-header-container">
        <Text text="Profil" type="h4" />
        <div className="profile-header-icon-container">
          <Icon
            icon="SortTop"
            className="profile-header-icon"
            size="20px"
            onClick={props.onIconClick}
          />
        </div>
      </div>
      <div className="first-line-container-profile mt-16">
        <div className="item-col-profile item-col-profile-margin-left">
          <div className="col-profile input-profile-container__edit-width">
            <Text
              text="Informations personnelles"
              className="profile-sub-title"
            />
          </div>
        </div>
        {windowWidth.innerWidth > 786 && (
          <div className="item-col-profile item-col-profile-margin-right input-profile-container__edit-width-display ">
            <div className="ml-a">
              <Button
                text="Ajouter un bénéficiaire"
                className="btn-beneficier-profile"
                boxShadow
                onClick={() => props.navigationSteps('ADD_BENEFICIAIRE_STEP1')}
              />
            </div>
          </div>
        )}
      </div>

      <div>
        <div className="mb-10">
          <InputProfileOrganism
            value={props.data.title}
            onChange={(value) => props.onChange(value, 'name')}
            classNameContainer="profile-title-container"
            classNameInput="profile-title-text"
          />
        </div>
        <div className="first-line-container-profile">
          <div className="item-col-profile item-col-profile-margin-left">
            <div className="col-profile">
              <InputProfileOrganism
                label={'Nom'}
                value={props.data.lastName}
                onChange={(value) => props.onChange(value, 'lastName')}
              />
            </div>
          </div>
          <div className="item-col-profile item-col-profile-margin-right">
            <InputProfileOrganism
              label={'Prénom'}
              value={props.data.name}
              onChange={(value) => props.onChange(value, 'name')}
            />
          </div>
        </div>
        <div className="second-line-container-profile">
          <div className="col-profile-container">
            <div className="col-profile second-items-container-profile">
              <div className="col-input-container-profile item-col-profile item-col-profile-margin-left">
                <InputProfileOrganism
                  label={'Date de naissance'}
                  value={props.data.birthDate}
                  onChange={(value) => props.onChange(value, 'birthDate')}
                />
              </div>
              <div className="col-input-container-profile item-col-profile item-col-profile-margin-right">
                <InputProfileOrganism
                  label={'Téléphone'}
                  value={props.data.tel}
                  onChange={(value) => props.onChange(value, 'tel')}
                  {...(props.editMail === false &&
                    props.editAdress === false && { edit: props.editTel })}
                  handelEditMode={(value) => props.handelEditTel(value)}
                />
              </div>
              {windowWidth.innerWidth > 768 && (
                <div className="pt-15">
                  <InputProfileOrganism
                    label={'N°Sécurité Sociale'}
                    value={props.data.numeroSecuriteSociale}
                    onChange={(value) =>
                      props.onChange(value, 'numeroSecuriteSociale')
                    }
                  />
                </div>
              )}

              {(props.editMail || props.editTel) &&
                windowWidth.innerWidth > 768 && (
                  <div className="col-input-container-profile item-col-profile item-col-profile-margin-left">
                    <div className="btn-submit-container-edit-tel">
                      <Button
                        text="Valider les modifications"
                        className="btn-submit-edit-profile"
                        onClick={() => props.showModal()}
                      />
                    </div>
                  </div>
                )}
            </div>
          </div>

          <div className="col-profile-container">
            <div className="col-input-container-profile">
              <InputProfileOrganism
                label={'Email'}
                value={props.data.mail}
                onChange={(value) => props.onChange(value, 'mail')}
                {...(props.editAdress === false &&
                  props.editTel === false && { edit: props.editMail })}
                handelEditMode={(value) => props.handelEditMail(value)}
              />
            </div>
            <div className="col-input-container-profile">
              <InputProfileOrganism
                {...(!props.manuelAddressEdit && { editable: true })}
                label={'Adresse'}
                {...(props.editMail === false &&
                  props.editTel === false && { edit: props.editAdress })}
                value={props.data.completeAdresse}
                onChange={(value) => {
                  props.onChange(value, 'completeAdresse');
                }}
                {...(!props.manuelAddressEdit && { autoComplete: true })}
                handelEditMode={(value) => props.handelEditAdresse(value)}
                autoComplete
                as={'autoComplete'}
                autoCompleteOption={props.optionAdressData}
                showDropDown={props.showDropDown}
                autoCompleteOptionClicked={props.autoCompleteOptionClicked}
                autoCompleteClickAway={props.autoCompleteClickAway}
              />
            </div>
            <div className="item-col-profile item-col-profile-margin-right col-input-container-profile">
              {props.editAdress &&
                props.editMail === false &&
                props.editTel === false && (
                  <div className="btn-edit-manuelle-adresse-profile-container">
                    <Button
                      text="Saisie manuelle"
                      className="btn-edit-manuelle-adresse-profile"
                      onClick={() => props.handelManuelAddressEdit(true)}
                    />
                  </div>
                )}
              {props.manuelAddressEdit && (
                <div className="ville-cp-input-container">
                  <div className="item-col-profile item-col-profile-margin-left">
                    <InputProfileOrganism
                      edit={true}
                      label={'Code postal'}
                      value={props.data.cp}
                      onChange={(value) => props.onChange(value, 'cp')}
                      {...(windowWidth.innerWidth > 768 && {
                        classNameContainer: 'input-ville-profile-container'
                      })}
                      {...(windowWidth.innerWidth > 768 && {
                        classNameInput: 'input-ville-profile'
                      })}
                    />
                  </div>
                  <div className="item-col-profile item-col-profile-margin-right">
                    <InputProfileOrganism
                      edit={true}
                      label={'Ville'}
                      value={props.data.ville}
                      onChange={(value) => props.onChange(value, 'ville')}
                      {...(windowWidth.innerWidth > 768 && {
                        classNameContainer: 'input-ville-profile-container'
                      })}
                      {...(windowWidth.innerWidth > 768 && {
                        classNameInput: 'input-ville-profile'
                      })}
                    />
                  </div>
                </div>
              )}
              {props.editAdress &&
                !props.editMail &&
                !props.editTel &&
                props.data.adresse && (
                  <Upload
                    type="single"
                    handleFileChange={props.selectFile}
                    contentClassName="upload-file-add-beneficiaire-profile-input"
                    classNameText="upload-text-add-beneficiaire-profile"
                    {...(windowWidth.innerWidth > 768 && {
                      child: (
                        <div className="btn-upload-container-profile">
                          <div className="upload-doc-adresse-profile">
                            <Text
                              text={
                                props.files.length
                                  ? props.files[0].name
                                  : 'Veuillez joindre un justificatif de domicile (obligatoire)'
                              }
                              className="placeholder-upload-doc-profile ellipse"
                            />
                            <Icon icon="Plus" size={14} />
                          </div>
                          <Text
                            text="6mo maximum autorisé"
                            className="condition-upload-doc-profile"
                          />
                        </div>
                      )
                    })}
                    style={{ display: 'none' }}
                    errorMsgClassName="profile-upload-error-message"
                    isUploadValid={props.isUploadAddressValid}
                    errorMsg={props.uploadAdressErrorMessage}
                  />
                )}
              {windowWidth.innerWidth <= 768 && (
                <div className={props.editAdress ? 'mt-15' : ''}>
                  <InputProfileOrganism
                    label={'N°Sécurité Sociale'}
                    value={props.data.numeroSecuriteSociale}
                    onChange={(value) =>
                      props.onChange(value, 'numeroSecuriteSociale')
                    }
                  />
                </div>
              )}
              <div
                className={
                  props.editAdress
                    ? 'profile-rattachement-container mt-15'
                    : 'profile-rattachement-container'
                }
              >
                <InputProfileOrganism
                  label={'Organisme de rattachement'}
                  value={props.data.rattachement}
                  onChange={(value) => props.onChange(value, 'rattachement')}
                />
              </div>
              {((props.editAdress && props.files.length) ||
                (props.editTel && windowWidth.innerWidth <= 768) ||
                (props.editMail && windowWidth.innerWidth <= 768)) && (
                <div className="btn-commit-edit-adresse-profile-big-container">
                  <div className="btn-commit-edit-adresse-profile-container">
                    <Button
                      text="Valider"
                      className="btn-submit-edit-adresse-profile"
                      onClick={() => props.showModal()}
                    />
                    <Button
                      text="Annuler"
                      className="btn-cancel-edit-adresse-profile"
                      onClick={() => props.handelEditAdresse(false)}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div></div>
      </div>
      <div className="profile-title-bank">
        <Text text="Informations bancaires" className="profile-sub-title" />
        <Icon
          style={{ cursor: 'pointer' }}
          icon={props.editBank ? 'CloseIcon' : 'Edit'}
          size={15}
          onClick={() =>
            props.editBank ? props.cancelEditBank() : props.handelEditBank(true)
          }
        />
      </div>
      <div className="profile-btn-bank-type">
        <Button
          text="Remboursements"
          className={
            props.data.remboursement
              ? 'btn-radio-bank-profile-selected'
              : 'btn-radio-bank-profile-unselected'
          }
          boxShadow
          onClick={() => props.onChangeBankType('remboursement')}
        />
        <Button
          text="Prélèvements"
          className={
            props.data.prelevement
              ? 'btn-radio-bank-profile-selected'
              : 'btn-radio-bank-profile-unselected'
          }
          boxShadow
          onClick={() => props.onChangeBankType('prelevement')}
        />
      </div>
      <div className="row-profile mb-55">
        <div className="col-profile-container">
          <div className="line-edit-bank-profile">
            <div className="col-profile col-profile-contained">
              <InputProfileOrganism
                label={'Propriétaire du compte'}
                value={
                  props.data?.remboursement
                    ? props.data?.repaymentAccountOwner ||
                      props.data.accountOwner
                    : props.data.accountOwner
                }
                edit={props.editBank}
                onChange={(value) => props.onChange(value, 'accountOwner')}
              />
            </div>
            <div className="name-bank-container col-profile-contained">
              <InputProfileOrganism
                label={'BIC'}
                value={
                  props.data?.remboursement
                    ? props.data?.repaymentBic || props.data.bic
                    : props.data.bic
                }
                edit={props.editBank}
                onChange={(value) => props.onChange(value, 'bic')}
              />
            </div>
          </div>
          <div className="line-edit-bank-profile">
            <div className="col-profile col-profile-contained">
              <div className="col-input-container-profile">
                <InputProfileOrganism
                  label={'IBAN'}
                  value={
                    props.data?.remboursement
                      ? props.data?.repaymentIban || props.data.iban
                      : props.data.iban
                  }
                  edit={props.editBank}
                  onChange={(value) => props.onChange(value, 'iban')}
                />
              </div>
            </div>
            <div className="name-bank-container col-profile-contained"></div>
          </div>
          <div className="line-edit-bank-profile">
            <div className="col-profile">
              {props.editBank && (
                <Upload
                  handleFileChange={props.selectFile}
                  contentClassName="upload-file-add-beneficiaire-profile-input"
                  classNameText="upload-text-add-beneficiaire-profile"
                  {...(windowWidth.innerWidth > 768 && {
                    child: (
                      <div className="btn-upload-container-profile-edit-bank">
                        <div className="upload-doc-adresse-profile">
                          <Text
                            text="Veuillez joindre un RIB (obligatoire)"
                            className="placeholder-upload-doc-profile"
                          />
                          <Icon icon="Plus" size={14} />
                        </div>
                      </div>
                    )
                  })}
                />
              )}
            </div>
          </div>
        </div>
      </div>

      {props.showConfirmationModal && (
        <ConfirmPasswordModal
          show={props.showConfirmationModal}
          onHide={props.onHide}
          modalStep={props.verificationSteps}
          title="Validation des modifications"
          firstText={`Nous venons d’envoyer un code par  email à l’adresse  ${props.data.mail}`}
          secondText="Veuillez le renseigner ci-dessous pour confirmer les modifications :"
          onConfirmCode={() => props.onConfirmCode()}
          onCancel={() => props.onHide()}
          successText="Vos modifications ont été enregistrées."
          classNameBtncancel="btn-cancel-modal-edit-profile"
          classNameBtnSubmit="btn-submit-modal-edit-profile"
          classNameInput="input-modal-edit-profile"
          onChange={(e) => props.onChangeCode(e.target.value)}
          code={props.code}
        />
      )}
    </div>
  );
}

export default TemplateProfileScreen2;
